var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "vsPrescriptionModal",
            tabindex: "-1",
            role: "dialog",
            "aria-hidden": "true",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-xl",
              attrs: { role: "document" },
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Prescription Information"),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "modal",
                        "aria-label": "Close",
                      },
                      on: { click: _vm.oncloseclick },
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×"),
                      ]),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "prescription-modal" }, [
                    _c("div", { staticClass: "prescription-languages" }, [
                      _c("h4", [_vm._v("Prescription Languages")]),
                      _c("div", { staticClass: "languages-block" }, [
                        _vm._m(0),
                        _c(
                          "label",
                          { staticClass: "container customcheck mart-10" },
                          [
                            _c("span", { attrs: { active: "" } }, [
                              _vm._v("English (English)"),
                            ]),
                            _c("input", {
                              attrs: { type: "checkbox", id: "English" },
                              domProps: {
                                checked: _vm.selectedLanguage === "en",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.selectLanguage("en")
                                },
                              },
                            }),
                            _c("span", { staticClass: "checkmark" }),
                          ]
                        ),
                        _c(
                          "label",
                          { staticClass: "container customcheck mart-10" },
                          [
                            _c("span", { attrs: { active: "" } }, [
                              _vm._v("Hindi (हिंदी)"),
                            ]),
                            _c("input", {
                              attrs: {
                                type: "checkbox",
                                id: "Hindi",
                                value: "hi",
                              },
                              domProps: {
                                checked: _vm.selectedLanguage === "hi",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.selectLanguage("hi")
                                },
                              },
                            }),
                            _c("span", { staticClass: "checkmark" }),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "prescription-tab" }, [
                      _vm._m(1),
                      _c(
                        "div",
                        {
                          staticClass: "tab-content",
                          attrs: { id: "myTabContent" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "tab-pane fade show active",
                              attrs: {
                                id: "medicines",
                                role: "tabpanel",
                                "aria-labelledby": "medicines-tab",
                              },
                            },
                            [
                              _c("div", { staticClass: "content-sec" }, [
                                _c(
                                  "div",
                                  { staticClass: "search-suggestions" },
                                  [
                                    _c("label", [
                                      _vm._v("Medicine Prescription"),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "container-comm" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "v-autocomplete favsims-search input",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "v-autocomplete-input-group",
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.searchMedicines,
                                                      expression:
                                                        "searchMedicines",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "v-autocomplete-input",
                                                  attrs: {
                                                    type: "search",
                                                    maxlength: "100",
                                                    placeholder:
                                                      "Search medicine",
                                                  },
                                                  domProps: {
                                                    value: _vm.searchMedicines,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.searchMedicines =
                                                        $event.target.value
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c("span", {
                                          staticClass: "addpre-search",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "checkbox-block" },
                                  _vm._l(_vm.medicinesList, function (item) {
                                    return _c(
                                      "label",
                                      {
                                        key: item.itemId,
                                        class: [
                                          "container customcheck mart-10 stock-available",
                                          item.currentStock > 0
                                            ? "stage-01"
                                            : "stage-03",
                                        ],
                                        attrs: {
                                          "data-toggle": "tooltip",
                                          "data-placement": "top",
                                          title:
                                            item.itemNameInEnglishOrFallback,
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              item.itemNameInEnglishOrFallback
                                            )
                                          ),
                                        ]),
                                        _c("input", {
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: _vm.isChecked(item.itemId),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.toggleSelection(
                                                item.itemId
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", {
                                          staticClass: "checkmark",
                                        }),
                                        _c(
                                          "em",
                                          { staticClass: "stock-count" },
                                          [_vm._v(_vm._s(item.currentStock))]
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _vm._m(2),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "tab-pane fade",
                              attrs: {
                                id: "lifestyle",
                                role: "tabpanel",
                                "aria-labelledby": "lifestyle-tab",
                              },
                            },
                            [
                              _c("div", { staticClass: "content-sec" }, [
                                _c(
                                  "div",
                                  { staticClass: "search-suggestions" },
                                  [
                                    _c("label", [
                                      _vm._v("Lifystyle Suggestions"),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "container-comm" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "v-autocomplete favsims-search input",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "v-autocomplete-input-group",
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.searchLifestyle,
                                                      expression:
                                                        "searchLifestyle",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "v-autocomplete-input",
                                                  attrs: {
                                                    type: "search",
                                                    maxlength: "100",
                                                    placeholder:
                                                      "Search suggestions",
                                                  },
                                                  domProps: {
                                                    value: _vm.searchLifestyle,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.searchLifestyle =
                                                        $event.target.value
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c("span", {
                                          staticClass: "addpre-search",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "checkbox-block" },
                                  _vm._l(_vm.lifestyleList, function (item) {
                                    return _c(
                                      "label",
                                      {
                                        key: item.itemId,
                                        staticClass:
                                          "container customcheck mart-10",
                                        attrs: {
                                          title:
                                            item.itemNameInEnglishOrFallback,
                                          "data-toggle": "tooltip",
                                          "data-placement": "top",
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              item.itemNameInEnglishOrFallback
                                            )
                                          ),
                                        ]),
                                        _c("input", {
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: _vm.isChecked(item.itemId),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.toggleSelection(
                                                item.itemId
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", {
                                          staticClass: "checkmark",
                                        }),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]),
                    _vm._m(3),
                  ]),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "prescriptionPreview",
            tabindex: "-1",
            "aria-labelledby": "prescriptionPreviewLabel",
            "aria-hidden": "true",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(4),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "preview-drag-modal" }, [
                  _c(
                    "div",
                    { staticClass: "preview-drag-block" },
                    [
                      _vm.selectedItemsData.length
                        ? _c(
                            "draggable",
                            {
                              staticClass: "list-group",
                              attrs: {
                                tag: "ul",
                                list: _vm.selectedItemsData,
                                handle: ".handle",
                                "item-key": "itemId",
                              },
                              on: { update: _vm.onDragEnd },
                            },
                            _vm._l(_vm.selectedItemsData, function (item) {
                              return _c(
                                "li",
                                {
                                  key: item.itemId,
                                  staticClass: "drag-main-block",
                                },
                                [
                                  _c("div", { staticClass: "drag-block" }, [
                                    _c("div", { staticClass: "top" }, [
                                      _c("div", [
                                        item.groupType == "Medicines"
                                          ? _c("i", {
                                              staticClass: "fa fa-stethoscope",
                                              attrs: { "aria-hidden": "true" },
                                            })
                                          : _c("i", {
                                              staticClass: "fa fa-heart-o",
                                            }),
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "main-content" },
                                        [
                                          _c("h4", [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.getItemName(item, "te")
                                                ) +
                                                "\n                          "
                                            ),
                                            _vm.selectedLanguage != "te"
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                            (" +
                                                      _vm._s(
                                                        _vm.getItemName(
                                                          item,
                                                          _vm.selectedLanguage
                                                        )
                                                      ) +
                                                      ")\n                          "
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]),
                                          _c("div", [
                                            _vm.editingItemId === item.itemId &&
                                            _vm.editingLang === "te"
                                              ? _c(
                                                  "div",
                                                  { staticClass: "edit-hold" },
                                                  [
                                                    _c("textarea", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.editableDesc,
                                                          expression:
                                                            "editableDesc",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      attrs: { rows: "3" },
                                                      domProps: {
                                                        value: _vm.editableDesc,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.editableDesc =
                                                            $event.target.value
                                                        },
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "edit-buttons",
                                                      },
                                                      [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "primary-btn ripple",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.saveDescription(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                Save\n                              "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "secondary-btn ripple",
                                                            on: {
                                                              click:
                                                                _vm.cancelEdit,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                Cancel\n                              "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "main-content-sub",
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "prescription-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getLanguageDesc(
                                                              item,
                                                              "te"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "edit-section bottom",
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "edit-icon",
                                                            attrs: {
                                                              href: "javascript:void(0);",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.editItem(
                                                                  item,
                                                                  "te"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-pencil",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                          ]),
                                          _vm.selectedLanguage != "te"
                                            ? _c("div", [
                                                _vm.editingItemId ===
                                                  item.itemId &&
                                                _vm.editingLang ===
                                                  _vm.selectedLanguage
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "edit-hold",
                                                      },
                                                      [
                                                        _c("textarea", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.editableDesc,
                                                              expression:
                                                                "editableDesc",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: { rows: "3" },
                                                          domProps: {
                                                            value:
                                                              _vm.editableDesc,
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.editableDesc =
                                                                $event.target.value
                                                            },
                                                          },
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "edit-buttons",
                                                          },
                                                          [
                                                            _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "primary-btn ripple",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.saveDescription(
                                                                        item
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                Save\n                              "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "secondary-btn ripple",
                                                                on: {
                                                                  click:
                                                                    _vm.cancelEdit,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                Cancel\n                              "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "main-content-sub",
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "prescription-text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                              " +
                                                                _vm._s(
                                                                  _vm.getLanguageDesc(
                                                                    item,
                                                                    _vm.selectedLanguage
                                                                  )
                                                                ) +
                                                                "\n                            "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "edit-section bottom",
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "edit-icon",
                                                                attrs: {
                                                                  href: "javascript:void(0);",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.editItem(
                                                                        item,
                                                                        _vm.selectedLanguage
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fa fa-pencil",
                                                                }),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "edit-section" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "del-icon",
                                              attrs: {
                                                href: "javascript:void(0);",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeItem(
                                                    item.itemId
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-trash",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "drag-icon handle" },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-ellipsis-v",
                                      }),
                                      _c("i", {
                                        staticClass: "fa fa-ellipsis-v",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._m(5),
                  _c("div", { staticClass: "text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "secondary-btn ripple",
                        attrs: { "data-dismiss": "modal" },
                      },
                      [
                        _vm._v(
                          "\n                Continue Editing\n              "
                        ),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "primary-btn ripple",
                        on: {
                          click: function ($event) {
                            return _vm.SavePrescription(false)
                          },
                        },
                      },
                      [_vm._v("\n                Save\n              ")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "primary-btn ripple",
                        on: {
                          click: function ($event) {
                            return _vm.SavePrescription(true)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                Print Prescription\n              "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          ref: "printSectionPrescription",
          staticStyle: {
            position: "absolute",
            top: "-9999px",
            left: "-9999px",
          },
          attrs: { id: "print-section-prescription" },
        },
        [
          _c("PrescriptionPrint", {
            attrs: {
              patient: _vm.patientInfo,
              selectedItemsData: _vm.selectedItemsData,
              doctorName: _vm.doctorName,
              time: _vm.prescriptioncreatedtime,
              selectedLanguage: _vm.selectedLanguage,
              created_by: _vm.created_by_unique_id,
              logoUrl: _vm.logoPath,
            },
          }),
        ],
        1
      ),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isdisplaymsg
            ? _c("Messages", {
                attrs: {
                  datamessage: _vm.sucessmsgtext,
                  iserror: _vm.iserrormsg,
                  isVisible: _vm.isdisplaymsg,
                },
                on: { closemsg: _vm.closeMessage },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "container customcheck mart-10" }, [
      _c("span", { attrs: { active: "" } }, [_vm._v("Telugu (తెలుగు)")]),
      _c("input", {
        attrs: { type: "checkbox", id: "Telugu", checked: "", disabled: "" },
      }),
      _c("span", { staticClass: "checkmark" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "ul",
      { staticClass: "nav nav-tabs", attrs: { id: "myTab", role: "tablist" } },
      [
        _c("li", { staticClass: "nav-item", attrs: { role: "presentation" } }, [
          _c(
            "button",
            {
              staticClass: "nav-link active",
              attrs: {
                id: "medicines-tab",
                "data-toggle": "tab",
                "data-target": "#medicines",
                type: "button",
                role: "tab",
                "aria-controls": "medicines",
                "aria-selected": "true",
              },
            },
            [
              _c("i", { staticClass: "fa fa-stethoscope" }),
              _vm._v(" Medicines\n                  "),
            ]
          ),
        ]),
        _c("li", { staticClass: "nav-item", attrs: { role: "presentation" } }, [
          _c(
            "button",
            {
              staticClass: "nav-link",
              attrs: {
                id: "lifestyle-tab",
                "data-toggle": "tab",
                "data-target": "#lifestyle",
                type: "button",
                role: "tab",
                "aria-controls": "lifestyle",
                "aria-selected": "false",
              },
            },
            [
              _c("i", { staticClass: "fa fa-heart-o" }),
              _vm._v(" Lifestyle Suggestions\n                  "),
            ]
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "legend-list" }, [
      _c("ul", [
        _c("li", { staticClass: "stock-legend legend-stage-01" }, [
          _c("span"),
          _vm._v("Available\n                        "),
        ]),
        _c(
          "li",
          {
            staticClass: "stock-legend legend-stage-02",
            attrs: { hidden: "" },
          },
          [_c("span"), _vm._v("Partially available\n                        ")]
        ),
        _c("li", { staticClass: "stock-legend legend-stage-03" }, [
          _c("span"),
          _vm._v("Out of stock\n                        "),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "text-right", staticStyle: { "margin-top": "20px" } },
      [
        _c(
          "button",
          {
            staticClass: "primary-btn ripple",
            attrs: {
              "data-toggle": "modal",
              "data-target": "#prescriptionPreview",
            },
          },
          [_vm._v("\n                Preview & Arrange\n              ")]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [
        _vm._v("Prescription Preview Drag to Reorder"),
      ]),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close",
          },
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "drag-legend" }, [
      _c("p", [_vm._v("This can be drag and drop to arrange")]),
      _c("span", [
        _c("i", { staticClass: "fa fa-ellipsis-v" }),
        _c("i", { staticClass: "fa fa-ellipsis-v" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }